var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"name-info-title"},[_vm._v(" "+_vm._s(_vm.nombreCompleto)+" "),_c('b',[_vm._v("("+_vm._s(_vm.pasajeros)+" Pax)")])]),_c('div',{staticClass:"mail-info-subtitle"},[_c('a',{attrs:{"href":'mailto:' + _vm.correo}},[_vm._v(_vm._s(_vm.correo))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }